import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=098802c2&"
import script from "./edit.vue?vue&type=script&lang=js&"
export * from "./edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('098802c2')) {
      api.createRecord('098802c2', component.options)
    } else {
      api.reload('098802c2', component.options)
    }
    module.hot.accept("./edit.vue?vue&type=template&id=098802c2&", function () {
      api.rerender('098802c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/countries/edit.vue"
export default component.exports